/* CUSTOM JV — mici interactiuni: descrierea colectiei „mai mult” (mobil) + textul SEO deschis pe desktop. */
(function () {
  function init() {
    document.querySelectorAll('[data-jv-clamp]').forEach(function (box) {
      var btn = box.querySelector('.jv-coll-desc__more');
      var text = box.querySelector('.jv-coll-desc__text');
      if (!btn || !text) return;
      var more = btn.textContent, less = btn.getAttribute('data-less') || more;
      // fara buton daca textul incape in 2 randuri
      if (text.scrollHeight <= text.clientHeight + 2) btn.hidden = true;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? less : more;
      });
    });
    var desktop = window.matchMedia('(min-width: 750px)');
    function syncDetails() {
      document.querySelectorAll('[data-jv-open-desktop]').forEach(function (d) { d.open = desktop.matches; });
    }
    syncDetails();
    if (desktop.addEventListener) desktop.addEventListener('change', syncDetails);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
